var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Company_honor"},[_c('p',{staticClass:"title"},[_vm._v("公司荣誉")]),_vm._v(" "),_c('img',{staticClass:"cup",attrs:{"src":_vm.cup}}),_vm._v(" "),_c('img',{staticClass:"cup_iouticons",attrs:{"src":_vm.cup_iouticons}}),_vm._v(" "),_c('img',{staticClass:"cup_text",attrs:{"src":_vm.cup_text}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8b87b04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/CompanyHonor.vue
// module id = null
// module chunks = 